import type { NewRelicErrorHandler } from '../types';

export const ERROR_IGNORE_SUBSTRINGS = [
  // clarity
  "Cannot read properties of null (reading 'disconnect')",
  'n.replace is not a function',
  'clarity',
  // hooper(carousel library)
  "undefined is not an object (evaluating 't.touches[0]')",
  // bigbrother投げてる途中でページ遷移すると起こる
  'XMLHttpRequestProgressEvent',
  // 401
  'Unauthorized',
  'Not Authenticated',
  'Received status code 401',
  'Request failed with status code 401',
  'Response not successful: Received status code 401',
  // 重複回答
  'Already Exists',
  // Timeout
  'timeout',
  'Request timed out',
  // Network error
  'Network Error',
  'Failed to fetch',
  'Load failed',
  'Request aborted',
  'socket is not opened',
  // 謎の拡張エラー
  'learningToolsRuntimeBridge',
  // 404
  'アンケートが見つかりません',
  // 404（Ponta の存在しない投票へのアクセス）
  '投票が見つかりません',
  // kenall 404（郵便番号検索の存在しない郵便番号）
  'error: kenall. AxiosError: Request failed with status code 404',
  // Chrome extensions
  'extensions/',
  'chrome://',
  'chrome-extension://',
  // local file
  'file://',
  'googletagmanager.com',
  // ブラウザ仕様上の警告（無害）
  'ResizeObserver loop',
] as const;

export function createErrorHandler(): NewRelicErrorHandler {
  return (error) => {
    if (!error) {
      return false;
    }

    const text = extractErrorText(error);
    if (!text) {
      return false;
    }

    const normalizedText = text.toLowerCase();

    const shouldIgnore = ERROR_IGNORE_SUBSTRINGS.some((substring) =>
      normalizedText.includes(substring.toLowerCase())
    );

    return shouldIgnore;
  };
}

// WebKit では error.stack に "Name: message" の先頭行が含まれないため、
// name / message / stack を結合してマッチング対象を広げる
export function extractErrorText(error: unknown): string | null {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    const parts = [error.name, error.message, error.stack].filter(Boolean);
    return parts.length > 0 ? parts.join('\n') : null;
  }

  if (typeof error === 'object' && error !== null) {
    const obj = error as { name?: unknown; message?: unknown; stack?: unknown };
    const parts = [obj.name, obj.message, obj.stack]
      .filter((v) => typeof v === 'string' && v.length > 0)
      .join('\n');
    return parts.length > 0 ? parts : null;
  }

  return null;
}
